import type { TFunction } from "i18next";
import { portLabel } from "../graph/nodeText";
import type { GraphNode, GraphPort } from "./workflowGraph";

/** A loaded step's port by the graph's own wording (`portLabel`); `null` where the step or the port can't be read. */
export function stepPortLabel(node: GraphNode | undefined, name: string, direction: GraphPort["direction"], t: TFunction, language?: string): string | null {
  if (node === undefined || (node.kind === "step" && node.step === null) || (node.kind === "sub_workflow" && node.workflow === null)) return null;
  const port = node.ports.find((candidate) => candidate.direction === direction && candidate.name === name);
  return port === undefined ? null : portLabel(node, port, t, language);
}
